import React, { useMemo } from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

function readCspNonce() {
  if (typeof document === "undefined") return "";
  return (
    document.querySelector('meta[property="csp-nonce"]')?.getAttribute("content") ||
    document.documentElement.getAttribute("data-csp-nonce") ||
    ""
  );
}

/**
 * Provides Emotion with a per-request CSP nonce so injected <style> tags
 * match style-src 'nonce-...' (no 'unsafe-inline').
 */
export default function EmotionCacheProvider({ children }) {
  const cache = useMemo(() => {
    const nonce = readCspNonce();
    return createCache({
      key: "css",
      nonce: nonce || undefined,
      prepend: true,
    });
  }, []);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
